
import { Component, Mixins } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "../form/Select.vue";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";

const orderModule = getModule(OrderModule);

@Component({
  components: {
    Select
  }
})
export default class OrderTypeSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  get types() {
    return orderModule.orderTypes.map((x: any) => ({ label: x.label, value: x.name }));
  }
}
